<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>Nuevo Permiso Acción CPE</h4>

    <div class="row">
        <div class="col-md-12">
            
            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Permiso/Acción CPE
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpAccion">Acción</label>

                                        <ng-select [items]="listAcciones"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdAccion"
                                                   loadingText="Cargando..."
                                                   [readonly]="!listAcciones || listAcciones.length === 0"
                                                   [loading]="!listAcciones || listAcciones.length === 0"
                                                   notFoundText="Acción no encontrada"
                                                   placeholder="-- Seleccione una Acción --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdAccion')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAccion','required')">
                                            La Acción es obligatoria
                                        </div>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAccion','registry_duplicated', true)">
                                            El permiso de esta Acción ya existe
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpPerfil">Perfil</label>

                                        <ng-select [items]="listPerfiles"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPerfil"
                                                   loadingText="Cargando..."
                                                   [readonly]="!listPerfiles || listPerfiles.length === 0"
                                                   [loading]="!listPerfiles || listPerfiles.length === 0"
                                                   notFoundText="Perfil no encontrado"
                                                   placeholder="-- Seleccione un Perfil --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPerfil')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPerfil','required')">
                                            El Perfil es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpEstadoCpe">Estado CPE</label>

                                        <ng-select [items]="listEstadosCertificadoPrevioEx"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdEstadoCpe"
                                                   loadingText="Cargando..."
                                                   [readonly]="!listEstadosCertificadoPrevioEx || listEstadosCertificadoPrevioEx.length === 0"
                                                   [loading]="!listEstadosCertificadoPrevioEx || listEstadosCertificadoPrevioEx.length === 0"
                                                   notFoundText="Estado CPE no encontrado"
                                                   placeholder="-- Seleccione un Estado CPE --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdEstadoCpe')"
                                                   appendTo="body">
                                        </ng-select>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpEdicion">Edición</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Edicion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

</div>
